if (!customElements.get('wrights-editorial-look')) {
  customElements.define('wrights-editorial-look', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.wrights-editorial-open');
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      this.querySelector('.wrights-editorial-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
